/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Custommailtemaplatesenabled3Inputs */

const en_entity_custommailtemaplatesenabled3 = /** @type {(inputs: Entity_Custommailtemaplatesenabled3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Mail Templates Enabled`)
};

const de_entity_custommailtemaplatesenabled3 = /** @type {(inputs: Entity_Custommailtemaplatesenabled3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzerdefinierte Mailvorlagen aktiviert`)
};

/**
* | output |
* | --- |
* | "Custom Mail Templates Enabled" |
*
* @param {Entity_Custommailtemaplatesenabled3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_custommailtemaplatesenabled3 = /** @type {((inputs?: Entity_Custommailtemaplatesenabled3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Custommailtemaplatesenabled3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_custommailtemaplatesenabled3(inputs)
	return de_entity_custommailtemaplatesenabled3(inputs)
});
export { entity_custommailtemaplatesenabled3 as "entity_customMailTemaplatesEnabled" }